module.exports = __webpack_public_path__ + "img/logo-pos.066b69f1.png";